import { DateTime } from "luxon";
import { useEffect, useMemo, useRef } from "react";

import { CALL_STATUS } from "@/constants/call";
import { useKpiByDateRange } from "@/hooks/queries/kpi.queries";
import { useCall } from "@/providers/hooks/use-call";
import { CallStatus } from "@/types/call.types";

import { KpiRow } from "./kpi-row";

export function HeaderKpi() {
    const { callStatus } = useCall();
    const previousCallStatusRef = useRef<CallStatus>(callStatus);

    const today = useMemo(() => DateTime.now(), []);
    const { data, refetch: refetchKpiData } = useKpiByDateRange(today, today);

    const kpiData = useMemo(() => data?.[today.toISODate()], [data, today.toISODate()]);

    useEffect(() => {
        const previousStatus = previousCallStatusRef.current;
        previousCallStatusRef.current = callStatus;

        if (callStatus === CALL_STATUS.DISCONNECTED && previousStatus !== CALL_STATUS.DISCONNECTED) {
            refetchKpiData();
        }
    }, [callStatus, refetchKpiData]);

    return <KpiRow kpiData={kpiData} className="mx-auto" />;
}
